import { service } from "@ember/service";
import Route from "@ember/routing/route";
import RSVP from "rsvp";

export default class DashboardHomeRoute extends Route {
  @service ajax;
  @service session;
  @service current;
  @service router;
  @service store;

  model() {
    let user = this.session.currentUser;
    let organizations = this.store.peekAll("organization");
    let hasOrganizations = organizations.length > 0;

    // Start fetching invites — populates the store for the header badge.
    // Only await the result for users without organizations (they stay on
    // the home page and need invites for the alert). Users with organizations
    // are redirected immediately; the fetch completes in the background.
    let invites = user?.isIndividual ? user.get("invites").reload() : Promise.resolve([]);

    return RSVP.hash({
      user,
      organizations,
      invites: hasOrganizations ? [] : invites,
    });
  }

  redirect({ organizations }) {
    let organization =
      organizations.find((organization) => organization.id === this.current.latestOrganizationFromLocalStorage) ||
      organizations.at(0);

    if (organization?.id) {
      return this.router.replaceWith("organization.overview", organization.id, {
        queryParams: { project: this.current.latestProjectFromLocalStorage || null },
      });
    }
  }
}
